export const ayurvedaAssessments = {

  agni: {
    title: "Agni Assessment",
    parameter: "Agni",
    questions: [
      {
        id: "hungerFrequency",
        text: "How frequent do you feel hunger?",
        options: [
          { value: "Mandagni", text: "I feel appetite less frequently (once/5-6 hours)" },
          { value: "Vishamagni", text: "My hunger fluctuates; sometimes I feel hungry, sometimes not" },
          { value: "Samagni", text: "My appetite is normal (once/4-5 hours)" },
          { value: "Tikshnagni", text: "I feel appetite frequently (every 2-3 hours)" }
        ]
      },
      {
        id: "mealFrequency",
        text: "How frequently do you have your meals in a day?",
        options: [
          { value: "Mandagni", text: "I have <2 meals per day" },
          { value: "Vishamagni", text: "My frequency of having meals varies between 1 and 4" },
          { value: "Samagni", text: "I usually have 2 to 3 meals per day" },
          { value: "Tikshnagni", text: "I almost always have >3 meals per day" }
        ]
      },
      {
        id: "mealQuantity",
        text: "What quantity of meals do you have in a day?",
        options: [
          { value: "Mandagni", text: "I usually have small meals" },
          { value: "Vishamagni", text: "I sometimes have large and sometimes small meals" },
          { value: "Samagni", text: "I usually have meals that are neither too small nor too large" },
          { value: "Tikshnagni", text: "I usually have large meals" }
        ]
      },
      {
        id: "digestionAbility",
        text: "What option describes best your ability to digest food?",
        options: [
          { value: "Mandagni", text: "I have medium digestive power, sometimes I face indigestion problem" },
          { value: "Vishamagni", text: "My ability to digest food keeps varying" },
          { value: "Samagni", text: "I have good digestion power" },
          { value: "Tikshnagni", text: "I have good digestion power; very rarely I get any digestion related issues" }
        ]
      }
    ]
  },

  koshta: {
    title: "Koshta Assessment",
    parameter: "Koshtam",
    questions: [
      {
        id: "bowelMovement",
        text: "Frequency of Bowel movements",
        options: [
          { value: "Mrdu", text: "Usually daily/more than once and consistent with timings" },
          { value: "Madhyama", text: "Occasionally irregular; otherwise, routine" },
          { value: "Krura", text: "Not regular and also time varies" }
        ]
      },
      {
        id: "stoolConsistency",
        text: "Consistency of stool",
        options: [
          { value: "Mrdu", text: "Mushy consistency/ semi solid/soft/ no firm shape" },
          { value: "Madhyama", text: "Well-formed / firm shape" },
          { value: "Krura", text: "Very hard or fragmented" }
        ]
      },
      {
        id: "evacuationSatisfaction",
        text: "Satisfaction on bowel evacuation – feeling of complete evacuation after defecation",
        options: [
          { value: "Mrdu", text: "Attained with more than one bowel evacuation" },
          { value: "Madhyama", text: "Attained with one evacuation" },
          { value: "Krura", text: "Dissatisfied" }
        ]
      }
    ]
  },
  vyayama: {
    title: "Vyayama Sakti Assessment",
    parameter: "Vyayamam",
    questions: [
      {
        id: "exerciseFrequency",
        text: "Exercise Frequency",
        options: [
          { value: "Uttama", text: "4–5 times/week" },
          { value: "Madhyama", text: "1-2 times/week" },
          { value: "Alpa", text: "Rarely/never" }
        ]
      },
      {
        id: "postExerciseFeeling",
        text: "How do you usually feel after doing moderate physical activity?",
        options: [
          { value: "Uttama", text: "Minimal fatigue after exercise" },
          { value: "Madhyama", text: "Occasional fatigue" },
          { value: "Alpa", text: "Tires quickly" }
        ]
      }
    ]
  },
  vyadhi: {
    title: "Vyadhi Avastha",
    parameter: "Vyadhiavastha",
    questions: [
      {
        id: "diseaseOnset",
        text: "Onset",
        options: [
          { value: "Asukari", text: "Sudden or recent (<1 month)" },
          { value: "Chirakari", text: "Gradual or long-standing (>3–6 months)" }
        ]
      },
      {
        id: "diseaseDuration",
        text: "Duration",
        options: [
          { value: "Asukari", text: "Short-term" },
          { value: "Chirakari", text: "Long-term or intermittent" }
        ]
      }
    ]
  },
  mala: {
    title: "Mala Assessment",
    parameter: "Malam",
    questions: [
      {
        id: "stoolConsistencyMala",
        text: "Consistency",
        options: [
          { value: "Ama-avastha", text: "Loose, sticky, slimy, or unformed" },
          { value: "Nirama-avastha", text: "Well-formed, firm but soft" }
        ]
      },
      {
        id: "stoolEvacuation",
        text: "Evacuation",
        options: [
          { value: "Ama-avastha", text: "Incomplete evacuation, feeling of heaviness even after passing" },
          { value: "Nirama-avastha", text: "Complete evacuation, lightness after passing" }
        ]
      },
      {
        id: "stoolOdorAppearance",
        text: "Odor & Appearance",
        options: [
          { value: "Ama-avastha", text: "Foul-smelling, sticky, may adhere to pan, may have mucus" },
          { value: "Nirama-avastha", text: "Mild odor, non-sticky, clean evacuation" }
        ]
      },
      {
        id: "stoolSinkFloat",
        text: "Sink/Float",
        options: [
          { value: "Ama-avastha", text: "Often sinks (heavier due to āma, stickiness, incomplete digestion)" },
          { value: "Nirama-avastha", text: "Tends to float (lighter, well-digested, balanced agni)" }
        ]
      }
    ]
  },
  manas: {
    title: "Manas/Sattva Assessment",
    parameter: "Manas",
    questions: [
      {
        id: "mentalStrength",
        text: "Are you mentally strong?",
        options: [
          { value: "Pravara", text: "Yes; I'm not easily disturbed by problems and also can support others" },
          { value: "Madhyama", text: "Not fully; gets disturbed by problems; but can easily overcome by own or with others support" },
          { value: "Avara", text: "No; easily disturbed by any problems and need others support to overcome" }
        ]
      }
    ]
  },
  mutra: {
    title: "Mutra Assessment",
    parameter: "Mutram",
    questions: [
      {
        id: "urinationFrequency",
        text: "How is your micturition (urination) frequency?",
        options: [
          { value: "Vata", text: "Approximately every 3 to 4 hours" },
          { value: "Pitta", text: "Approximately every 2 hours" },
          { value: "Kapha", text: "Approximately every 5 to 6 hours" }
        ]
      },
      {
        id: "urineAppearance",
        text: "What best describes the appearance of your urine?",
        options: [
          { value: "Vata", text: "Resembles clear water, very thin and watery" },
          { value: "Pitta", text: "Yellow or reddish in color, scanty" },
          { value: "Kapha", text: "White or cloudy, thick, dense, or sticky" }
        ]
      },
      {
        id: "urinationSensation",
        text: "What sensation do you feel while urinating?",
        options: [
          { value: "Vata", text: "No sensation / dryness" },
          { value: "Pitta", text: "Mild to strong burning" },
          { value: "Kapha", text: "Sticky feeling" }
        ]
      }
    ]
  },
  nidra: {
    title: "Nidra Assessment",
    parameter: "Nidra",
    questions: [
      {
        id: "sleepDuration",
        text: "Duration",
        options: [
          { value: "Normal", text: "6-8 hours" },
          { value: "Alpa", text: "Less than 6 hours; frequent or early waking" },
          { value: "Atinidra", text: "More than 8 hours; may include daytime sleep" }
        ]
      },
      {
        id: "sleepQuality",
        text: "Quality",
        options: [
          { value: "Normal", text: "Deep, uninterrupted, refreshing" },
          { value: "Alpa", text: "Light, disturbed, non-restorative" },
          { value: "Atinidra", text: "Heavy, dull, unrefreshing" }
        ]
      }
    ]
  }
};